// extracted by mini-css-extract-plugin
export default {"userDetailsPanel":"UserDetailsPanelComponent_userDetailsPanel__rcMbs","container":"UserDetailsPanelComponent_container__i9e5X"};